import { render, staticRenderFns } from "./VirtualSchedule.vue?vue&type=template&id=c3a0c7d4&"
import script from "./VirtualSchedule.vue?vue&type=script&lang=js&"
export * from "./VirtualSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports